"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPLOYMENT_STATUS = void 0;
exports.DEPLOYMENT_STATUS = {
    NEW: 'NEW',
    DEPLOYED: 'DEPLOYED',
    NEED_TO_ARCHIVE: 'NEED_TO_ARCHIVE',
    ARCHIVED: 'ARCHIVED'
};
//# sourceMappingURL=deploymentStatus.js.map